import { render, staticRenderFns } from "./StepItemDialog.vue?vue&type=template&id=23b8c49c"
import script from "./StepItemDialog.vue?vue&type=script&lang=js"
export * from "./StepItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports